import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';

import util from '@util';
import { queryStatisticsFundsBook } from '@api/finance/funds';

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { uuid } = this.props;
    this.loadStatistics(uuid);
  }

  /**
   * 获取账号统计
   */
  loadStatistics = uuid => {
    queryStatisticsFundsBook(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({ statistics: res.data });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { statistics } = this.state;
    return (
      <Card className="description">
        <Row type="flex" justify="space-around" align="middle">
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">所属公司:</span> <span>{statistics.companyName}</span>
            </p>
            <p>
              <span className="title">账户余额:</span>
              <span className="title">
                {util.numberFormat(statistics.currentBalance, 2, '.', ',')}
                {statistics.unit ? `(${statistics.unit})` : '(元)'}
              </span>
            </p>
          </Col>
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">总收入:</span>
              <span>
                {util.numberFormat(statistics.incomeSum, 2, '.', ',')}
                {statistics.unit ? `(${statistics.unit})` : '(元)'}
              </span>
            </p>
            <p>
              <span className="title">总支出:</span>
              <span>
                {util.numberFormat(statistics.expenditureSum, 2, '.', ',')}
                {statistics.unit ? `(${statistics.unit})` : '(元)'}
              </span>
            </p>
          </Col>
          <Col span={6}>
            <p style={{ marginBottom: '16px' }}>
              <span className="title">收入款项:</span> <span>{statistics.incomeCount}</span>笔
            </p>
            <p>
              <span className="title">支出款项:</span> <span>{statistics.expenditureCount}</span>笔
            </p>
          </Col>
        </Row>
      </Card>
    );
  }
}
export default FinanceCapitalDetail;



// WEBPACK FOOTER //
// ./src/components/finance/funds/detail/CardStatic.js